import React, { useEffect, useState } from 'react';
import { Dialog, Typography, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(3),
  },
}));

const ActionTimerDialog = ({
  countdownTime = 3,
  open = false,
  onClose = () => {},
  title='Great! You are now ready for the interview.',
  timerMessage = 'Starting in {timeLeft} seconds...',
}) => {
  const classes = useStyles();
  
  const [timeLeft, setTimeLeft] = useState(countdownTime);

  useEffect(() => {
    if (timeLeft <= 0) {
      onClose();
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft, onClose]);

  const parsedMessage = timerMessage.replace('{timeLeft}', timeLeft);

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      disableBackdropClick
      PaperProps={{
        sx: { padding: 4, textAlign: 'center', width: 648, height: 360 },
      }}
    >
      <Box className={classes.container}>
        <img
          src='https://assets.languify.in/images/check-contained.png'
          alt='check'
        />
        <Typography variant='h5-medium' color='neutral.clr-900'>
          {title}
        </Typography>
        <Typography variant='h6-medium' color='neutral.clr-500'>
          {parsedMessage}
        </Typography>
      </Box>
    </Dialog>
  );
};

export default ActionTimerDialog;
